import React, {createContext, useReducer} from 'react';
import PropTypes from 'prop-types';
import reducer from './reducer';
import stateActions from './actions';
import defaultConfig from '../configs/index';

import settings from '../conf/settings';
const { PERFORM_HEALTH_CHECK } = settings.environment;

export const defaultInitialState = {
  healthCheckPassedOrNotRequired: !PERFORM_HEALTH_CHECK, // setting to false will initiate a health check
  payment: null,
  modals: [],
  configuration: defaultConfig,
  tokens: {
    validatePayment: null,
    recipientLogin: null,
  },
  accounts: null,
  selectedPaymentNetwork: null,
  renderId: null,
};

/*
  because we can't redirect the user back to their unique paywall url after returning from OAuthFlow, we cache the application state in session storage before initiating OAuthFlow and then use the cached state to initialize our application state when returning from OAuth
*/
// TODO error handling for returning from oauth
export const StateContext = createContext(defaultInitialState);

export const StateProvider = ({children, initialState, ...other}) => {
  const appState = initialState || {...defaultInitialState};

  return (
    <StateContext.Provider value={useReducer(reducer, appState)} {...other}>
      {children}
    </StateContext.Provider>
  );
};

StateProvider.propTypes = {
  children: PropTypes.any,
  initialState: PropTypes.object,
};

export const actions = stateActions;
